import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from '../../../components/Button';
import messages from '../../messages';
import { ExpenseClaimedItem } from './ExpenseClaimedItem';

export class ExpensesClaimed extends React.Component {
  componentDidMount() {
    if (this.props.data.length <= 0) {
      this.addItem();
    }
  }

  onRemove = (id) => {
    let arrayData = this.props.data;

    // find and remove item from data by id
    arrayData = arrayData.filter((t) => t.id !== id);

    this.onChange(arrayData);
  };

  onItemChanged = (itemChanged) => {
    const item = this.props.data.filter((t) => t.id === itemChanged.id)[0];

    if (item) {
      // find and update item by id
      const newData = this.props.data.map(
        (el) => el.id === itemChanged.id ? Object.assign({}, el, itemChanged) : el,
      );

      this.onChange(newData);
    }
  };

  onChange = (data) => {
    if (this.props.onChange) {
      this.props.onChange(data);
    }
  };

  addItem = () => {
    const arrayData = this.props.data;

    arrayData.push({
      id: new Date().getTime().toString(),
      dateOfExpense: '',
      description: '',
      amount: '',
      currency: '',
      supportingDocumentsAttached: 'false',
    });

    this.onChange(arrayData);
  };

  render() {
    const removable = this.props.data.length > 1;
    const { disabled, data, expenseType } = this.props;

    return (
      <div>
        {data.map((item, index) => (
          <ExpenseClaimedItem
            {...this.props}
            index={index}
            key={item.id}
            item={item}
            onChange={this.onItemChanged}
            onRemove={this.onRemove}
            removable={removable}
            disabled={disabled}
            expenseType={expenseType}
          />))}
        {!disabled &&
        <div className="row">
          <div className="col-auto">
            <Button onClick={this.addItem}>
              {(expenseType === 1) && <FormattedMessage {...messages.addExpense} />}
              {expenseType === 2 && <FormattedMessage {...messages.addGolfExpense} />}
              {expenseType === 3 && <FormattedMessage {...messages.addBicycleExpense} />}
              {(expenseType === 4) && <FormattedMessage {...messages.addOtherExpense} />}
            </Button>
          </div>
        </div>}
      </div>
    );
  }
}

ExpensesClaimed.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.array,
  disabled: PropTypes.bool,
  expenseType: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepOther/components/ExpensesClaimed/index.js